/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_To_Play_Modes_BodyInputs */

const bn_how_to_play_modes_body = /** @type {(inputs: How_To_Play_Modes_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ক্লাসিক হল ওপেন-এন্ডেড স্কোরিং, 3টি মিসের পর 3টি লাইভস শেষ হয়, ক্যাপিটালস ক্যাপিটাল-সিটি উত্তরের জন্য দেশ অদলবদল করে এবং প্রথম ভুলের জন্য স্ট্রিক শেষ হয়।`)
};

const de_how_to_play_modes_body = /** @type {(inputs: How_To_Play_Modes_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`„Klassisch“ ist eine offene Wertung, „3 Leben“ endet nach drei Fehlschüssen, „Hauptstädte“ tauscht Länder gegen Antworten in der Hauptstadt aus und „Streak“ endet mit dem ersten Fehler.`)
};

const el_how_to_play_modes_body = /** @type {(inputs: How_To_Play_Modes_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Το Classic είναι σκοράρισμα ανοιχτού τύπου, το 3 Lives τελειώνει μετά από τρεις αστοχίες, το Capitals ανταλλάσσει χώρες με απαντήσεις πρωτεύουσας-πόλης και το σερί τελειώνει με το πρώτο λάθος.`)
};

const en_how_to_play_modes_body = /** @type {(inputs: How_To_Play_Modes_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classic is open-ended scoring, 3 Lives ends after three misses, Capitals swaps countries for capital-city answers, and Streak ends on the first mistake.`)
};

const es_how_to_play_modes_body = /** @type {(inputs: How_To_Play_Modes_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classic es una puntuación abierta, 3 Lives termina después de tres fallos, Capitals cambia países por respuestas de ciudades capitales y Streak termina con el primer error.`)
};

const fr_how_to_play_modes_body = /** @type {(inputs: How_To_Play_Modes_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classique offre un score ouvert, 3 Vies se termine après trois erreurs, Capitales remplace les pays par des réponses de villes capitales, et Série se termine à la première erreur.`)
};

const hi_how_to_play_modes_body = /** @type {(inputs: How_To_Play_Modes_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्लासिक ओपन-एंड स्कोरिंग है, 3 लाइव्स तीन चूक के बाद समाप्त होता है, कैपिटल्स कैपिटल-सिटी उत्तरों के लिए देशों की अदला-बदली करता है, और स्ट्रीक पहली गलती पर समाप्त होता है।`)
};

const hu_how_to_play_modes_body = /** @type {(inputs: How_To_Play_Modes_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Classic egy nyílt végű pontozás, a 3 Élet három kihagyás után ér véget, a Capitals országot cserél a fővárosi válaszokra, a sorozat pedig az első hibára ér véget.`)
};

const id_how_to_play_modes_body = /** @type {(inputs: How_To_Play_Modes_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klasik adalah penilaian terbuka, 3 Kehidupan berakhir setelah tiga kali gagal, Ibukota bertukar negara untuk jawaban ibu kota, dan Streak berakhir pada kesalahan pertama.`)
};

const it_how_to_play_modes_body = /** @type {(inputs: How_To_Play_Modes_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classic ha un punteggio a tempo indeterminato, 3 Lives termina dopo tre errori, Capitals scambia i paesi con le risposte delle capitali e Streak termina al primo errore.`)
};

const ja_how_to_play_modes_body = /** @type {(inputs: How_To_Play_Modes_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クラシックはオープンエンドのスコアリングで、3 Lives は 3 回ミスすると終了し、Capitals は国と首都の答えを交換し、Streak は最初のミスで終了します。`)
};

const ko_how_to_play_modes_body = /** @type {(inputs: How_To_Play_Modes_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classic은 무제한 득점 방식이고, 3 Lives는 3회 실패 후 종료되며, Capitals는 국가를 수도 도시 답변으로 교환하고, Streak는 첫 번째 실수로 종료됩니다.`)
};

const nl_how_to_play_modes_body = /** @type {(inputs: How_To_Play_Modes_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klassiek is een score met een open einde, 3 levens eindigen na drie missers, hoofdsteden ruilen landen in voor antwoorden op hoofdsteden en Streak eindigt bij de eerste fout.`)
};

const pl_how_to_play_modes_body = /** @type {(inputs: How_To_Play_Modes_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klasyczna to punktacja otwarta, 3 życia kończą się po trzech pudłach, Capitals zamieniają kraje na odpowiedzi dotyczące stolic, a Seria kończy się pierwszym błędem.`)
};

const pt_how_to_play_modes_body = /** @type {(inputs: How_To_Play_Modes_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classic é uma pontuação aberta, 3 Lives termina após três erros, Capitals troca países por respostas da capital e Streak termina no primeiro erro.`)
};

const ru_how_to_play_modes_body = /** @type {(inputs: How_To_Play_Modes_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Классическая игра имеет открытый подсчет очков, игра «3 жизни» заканчивается после трех промахов, «Кэпиталз» меняет страны на ответы столицы, а «Стрик» заканчивается при первой ошибке.`)
};

const sv_how_to_play_modes_body = /** @type {(inputs: How_To_Play_Modes_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classic är oavslutade poäng, 3 liv slutar efter tre missar, Capitals byter länder mot huvudstadssvar och Streak slutar på första misstaget.`)
};

const tr_how_to_play_modes_body = /** @type {(inputs: How_To_Play_Modes_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klasik, açık uçlu puanlamadır, 3 Hayat, üç ıskalamanın ardından sona erer, Başkentler, başkent yanıtları için ülkeleri değiştirir ve Seri, ilk hatada sona erer.`)
};

const uk_how_to_play_modes_body = /** @type {(inputs: How_To_Play_Modes_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Класичний — це безстроковий підрахунок очок, 3 життя закінчуються після трьох промахів, «Столиці» змінюють країни на відповіді «столиця», а «Серія» завершується після першої помилки.`)
};

const vi_how_to_play_modes_body = /** @type {(inputs: How_To_Play_Modes_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cổ điển là tính điểm có kết thúc mở, 3 Mạng sống kết thúc sau ba lần trượt, Thủ đô hoán đổi các quốc gia để lấy câu trả lời về thủ đô và Streak kết thúc ở sai lầm đầu tiên.`)
};

const zh_how_to_play_modes_body = /** @type {(inputs: How_To_Play_Modes_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classic 是开放式计分，3 Lives 在 3 次失误后结束，Capitals 将国家换成首都城市的答案，Streak 在第一个错误时结束。`)
};

const zh_hant_how_to_play_modes_body = /** @type {(inputs: How_To_Play_Modes_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classic 是開放式計分，3 Lives 在 3 次失誤後結束，Capitals 將國家換成首都城市的答案，Streak 在第一個錯誤時結束。`)
};

/**
* | output |
* | --- |
* | "Classic is open-ended scoring, 3 Lives ends after three misses, Capitals swaps countries for capital-city answers, and Streak ends on the first mistake." |
*
* @param {How_To_Play_Modes_BodyInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const how_to_play_modes_body = /** @type {((inputs?: How_To_Play_Modes_BodyInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_To_Play_Modes_BodyInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_how_to_play_modes_body(inputs)
	if (locale === "de") return de_how_to_play_modes_body(inputs)
	if (locale === "el") return el_how_to_play_modes_body(inputs)
	if (locale === "en") return en_how_to_play_modes_body(inputs)
	if (locale === "es") return es_how_to_play_modes_body(inputs)
	if (locale === "fr") return fr_how_to_play_modes_body(inputs)
	if (locale === "hi") return hi_how_to_play_modes_body(inputs)
	if (locale === "hu") return hu_how_to_play_modes_body(inputs)
	if (locale === "id") return id_how_to_play_modes_body(inputs)
	if (locale === "it") return it_how_to_play_modes_body(inputs)
	if (locale === "ja") return ja_how_to_play_modes_body(inputs)
	if (locale === "ko") return ko_how_to_play_modes_body(inputs)
	if (locale === "nl") return nl_how_to_play_modes_body(inputs)
	if (locale === "pl") return pl_how_to_play_modes_body(inputs)
	if (locale === "pt") return pt_how_to_play_modes_body(inputs)
	if (locale === "ru") return ru_how_to_play_modes_body(inputs)
	if (locale === "sv") return sv_how_to_play_modes_body(inputs)
	if (locale === "tr") return tr_how_to_play_modes_body(inputs)
	if (locale === "uk") return uk_how_to_play_modes_body(inputs)
	if (locale === "vi") return vi_how_to_play_modes_body(inputs)
	if (locale === "zh") return zh_how_to_play_modes_body(inputs)
	return zh_hant_how_to_play_modes_body(inputs)
});